"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const React = __importStar(require("react"));
const core_1 = require("@emotion/core");
const AnimatedRadio_1 = __importDefault(require("orbiter-web-components/src/components/input/AnimatedRadio"));
class CustomRadio extends React.Component {
    render() {
        const smallMargin = (theme) => {
            return core_1.css `
                margin-bottom: 10px;
                ${this.props.radioStyle ? this.props.radioStyle(theme) : ''}
            `;
        };
        return (core_1.jsx("div", { css: core_1.css `max-width: 500px; margin-left: auto; margin-right: auto;` },
            core_1.jsx(AnimatedRadio_1.default, Object.assign({}, this.props, { radioStyle: smallMargin }))));
    }
}
exports.default = CustomRadio;
//# sourceMappingURL=CustomRadio.js.map